import { useEffect, useState } from 'react'

export const useListrakReady = () => {
  const isLibLoaded = getIsLibLoaded()
  const [isLoaded, setIsLoaded] = useState<boolean>(isLibLoaded)
  const [intervalId, setIntervalId] = useState<number | undefined>()

  useEffect(() => {
    function checkScriptLoaded () {
      if (getIsLibLoaded()) {
        setIsLoaded(true)
      }
    }

    if (!intervalId && !isLibLoaded) {
      const id = window.setInterval(checkScriptLoaded, 1000)
      setIntervalId(id)
    }

    if (isLibLoaded) {
      window.clearInterval(intervalId)
    }

    return () => {
      window.clearInterval(intervalId)
    }
  }, [
    isLibLoaded,
    intervalId,
    setIntervalId,
    setIsLoaded
  ])

  return {
    isLoaded
  }
}

// @ts-expect-error
const getIsLibLoaded = () => (typeof window._ltk_util == 'object') && (typeof window._ltk == 'object')
